import { Inject, LOCALE_ID, Pipe, PipeTransform } from '@angular/core';
import { DatePipe } from '@angular/common';
import { TIME_ZONE } from '@shared/injectors/time-zone.service';
import { LocalizeService } from '@services/helpers/localize/localize.service';

@Pipe({
    name: 'localizedDate',
    standalone: true
})
export class LocalizedDatePipe implements PipeTransform {

  constructor(@Inject(LOCALE_ID) private locale: string, @Inject(TIME_ZONE) private timeZone: string, private localize: LocalizeService) {
  }

  transform(value: any, pattern: string = 'mediumDate'): string {
    if (value === null || value === '' || typeof value === 'undefined') {
      return null;
    }

    const locale = this.localize.currentLocaleValue;

    if (typeof value === 'string' && !value.includes('Z')) {
      value += 'Z';
    }

    return new DatePipe(locale).transform(value, pattern, this.timeZone);
  }
}
